import { InquiryStatusType } from '../enums/inbox/inquiryStatusType.enum';
export const inquiryStatusElements = {
    LIST: [
        // { title: 'Zaključeno', id: InquiryStatusType.FINISHED, class: 'btn-success' },
        { title: 'Novo', id: InquiryStatusType.NEW, class: 'btn-brand' },
        { title: 'Poklicani', id: InquiryStatusType.CALL_MADE, class: 'btn-success' },
        { title: 'Čakanje', id: InquiryStatusType.DOCUMENTATION_WAITING, class: 'btn-danger' },
        { title: 'Pridobljeno', id: InquiryStatusType.DOCUMENTATION_RECIVED, class: 'btn-warning' },
        { title: 'Naročeni', id: InquiryStatusType.RESERVATION_DONE, class: 'btn-metal' },
        { title: 'Preklic', id: InquiryStatusType.CANCELED, class: 'btn-danger' },
    ],
};
